/**
 * SHAR-1060 - a duration stored as decimal hours, written the way the quote form
 * enters it: "1 h 53 m", not "1.89h".
 *
 * Minutes are rounded to the nearest whole minute, the same rounding the form
 * uses, and a rounding that reaches 60 carries into the hour (1.9999 is "2 h 0 m",
 * never "1 h 60 m").
 */
export function formatHoursMinutes(hours: number | null | undefined): string {
  if (hours == null || !Number.isFinite(Number(hours)) || Number(hours) < 0) return '—';
  const total = Math.round(Number(hours) * 60);
  return `${Math.floor(total / 60)} h ${total % 60} m`;
}

/**
 * estFlightTimeHours (decimal hours) → "2h 45m", as the ShareJet and charter
 * booking itineraries write it. Not formatHoursMinutes() above, which writes
 * "2 h 45 m" and "—" for a negative value.
 */
export function fmtFlightTime(h: number | null | undefined): string {
  if (h == null) return '—';
  const total = Math.max(0, Math.round(h * 60));
  const hh = Math.floor(total / 60);
  const mm = total % 60;
  if (hh && mm) return `${hh}h ${mm}m`;
  if (hh) return `${hh}h`;
  return `${mm}m`;
}
